import React from 'react';
import {motion} from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const {FiMail,FiPhone,FiMapPin,FiSend,FiMusic,FiCalendar,FiDollarSign,FiMessageCircle,FiExternalLink}=FiIcons;

function Contact() {
  const contactInfo = [
    {
      icon: FiMail,
      title: 'General Inquiries',
      details: 'bigcitysupreme@gmail.com',
      description: 'For general questions, fan mail, or marriage proposals (we\'re flattered, but taken by our music)'
    },
    {
      icon: FiCalendar,
      title: 'Booking & Shows',
      details: 'bigcitysupreme@gmail.com',
      description: 'Want us to rock your venue? Let\'s make some noise together (literally)'
    },
    {
      icon: FiMusic,
      title: 'Press & Media',
      details: 'bigcitysupreme@gmail.com',
      description: 'Interviews, reviews, and photo shoots. We promise to wear our matching outfits'
    },
    {
      icon: FiDollarSign,
      title: 'Business & Licensing',
      details: 'bigcitysupreme@gmail.com',
      description: 'Want to use our music? Let\'s talk numbers (and by numbers, we mean reasonable numbers)'
    }
  ];

  const socialLinks = [
    {name: 'Spotify', url: 'https://open.spotify.com/artist/1y4LSBAOXKcnWoCL0OgtHU', color: 'green'},
    {name: 'Bandcamp', url: 'https://bigcitysupreme.bandcamp.com/album/super-deluxe', color: 'blue'},
    {name: 'Instagram', url: '#', color: 'pink'},
    {name: 'Facebook', url: '#', color: 'blue'}
  ];

  return (
    <div className="min-h-screen pt-20">
      {/* Hero Section */}
      <section className="py-20 bg-gradient-to-b from-black to-gray-900">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <motion.h1 
            className="text-5xl md:text-7xl font-bold bebas-neune gradient-text mb-6"
            initial={{opacity: 0, y: 50}}
            animate={{opacity: 1, y: 0}}
            transition={{duration: 0.8}}
          >
            GET IN TOUCH
          </motion.h1>
          <motion.p 
            className="text-xl md:text-2xl text-gray-300 max-w-4xl mx-auto"
            initial={{opacity: 0, y: 30}}
            animate={{opacity: 1, y: 0}}
            transition={{duration: 0.8, delay: 0.2}}
          >
            We're always happy to hear from fans, venues, and anyone else who appreciates quality alternative rock from the great white north.
          </motion.p>
        </div>
      </section>

      {/* Contact Info Cards */}
      <section className="py-20 bg-gray-900">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            {contactInfo.map((info, index) => (
              <motion.div 
                key={index}
                className="bg-gradient-to-br from-black to-gray-800 rounded-lg p-6 border border-red-600/20 hover:border-red-600/40 transition-all duration-300"
                initial={{opacity: 0, y: 50}}
                whileInView={{opacity: 1, y: 0}}
                transition={{duration: 0.6, delay: index * 0.1}}
                viewport={{once: true}}
                whileHover={{scale: 1.05}}
              >
                <div className="bg-red-600 rounded-full w-12 h-12 flex items-center justify-center mb-4">
                  <SafeIcon icon={info.icon} className="h-6 w-6 text-white" />
                </div>
                <h3 className="text-xl font-bold text-white mb-2">{info.title}</h3>
                <a 
                  href={`mailto:${info.details}`} 
                  className="text-yellow-400 font-semibold hover:text-yellow-300 transition-colors block mb-3"
                >
                  {info.details}
                </a>
                <p className="text-gray-400 text-sm leading-relaxed">{info.description}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Clever Contact Section */}
      <section className="py-20 bg-black">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div 
            className="text-center mb-12"
            initial={{opacity: 0, y: 30}}
            whileInView={{opacity: 1, y: 0}}
            transition={{duration: 0.8}}
            viewport={{once: true}}
          >
            <h2 className="text-4xl md:text-5xl font-bold bebas-neune gradient-text mb-4">
              The Direct Line to Rock
            </h2>
            <p className="text-gray-300 text-lg mb-8">
              Forget complicated forms and CAPTCHAs that make you question if you're human. 
              We're old school - we like emails that go straight to our inbox.
            </p>
          </motion.div>

          <motion.div 
            className="bg-gradient-to-br from-gray-900 to-gray-800 rounded-lg p-12 border border-gray-700 text-center"
            initial={{opacity: 0, y: 50}}
            whileInView={{opacity: 1, y: 0}}
            transition={{duration: 0.8}}
            viewport={{once: true}}
          >
            <div className="text-6xl mb-6">📧</div>
            <h3 className="text-2xl font-bold text-white mb-4">
              Email Us Like It's 1999
            </h3>
            <p className="text-gray-300 mb-8 max-w-2xl mx-auto">
              That's right - just click the button below and your email client will magically appear. 
              No forms, no waiting, no "please verify you're not a robot" (we assume you're not).
            </p>
            
            <a 
              href="mailto:bigcitysupreme@gmail.com?subject=Hey%20Big%20City%20Supreme!&body=I%20found%20you%20online%20and%20wanted%20to%20say..."
              className="inline-flex items-center space-x-3 bg-red-600 hover:bg-red-700 px-8 py-4 rounded-full font-bold text-lg text-white transition-all duration-300 transform hover:scale-105"
            >
              <SafeIcon icon={FiMail} className="h-6 w-6" />
              <span>Open Your Email Client</span>
              <SafeIcon icon={FiExternalLink} className="h-5 w-5" />
            </a>

            <div className="mt-8 p-4 bg-yellow-900/20 border border-yellow-500/30 rounded-lg max-w-2xl mx-auto">
              <p className="text-yellow-300 text-sm font-medium mb-2">Pro Tip:</p>
              <p className="text-gray-300 text-sm">
                Include "Fan Mail", "Booking Inquiry", or "I Need More Rock in My Life" in the subject line 
                for priority processing (aka we'll read it first).
              </p>
            </div>
          </motion.div>
        </div>
      </section>

      {/* Social Media */}
      <section className="py-20 bg-gray-900">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <motion.h2 
            className="text-4xl md:text-5xl font-bold bebas-neune gradient-text mb-8"
            initial={{opacity: 0, y: 30}}
            whileInView={{opacity: 1, y: 0}}
            transition={{duration: 0.8}}
            viewport={{once: true}}
          >
            Find Us Online
          </motion.h2>
          <motion.p 
            className="text-xl text-gray-300 mb-8"
            initial={{opacity: 0, y: 30}}
            whileInView={{opacity: 1, y: 0}}
            transition={{duration: 0.8, delay: 0.2}}
            viewport={{once: true}}
          >
            We're social media butterflies... if butterflies posted guitar solos and tour dates.
          </motion.p>
          <motion.div 
            className="grid grid-cols-2 md:grid-cols-4 gap-6"
            initial={{opacity: 0, y: 30}}
            whileInView={{opacity: 1, y: 0}}
            transition={{duration: 0.8, delay: 0.4}}
            viewport={{once: true}}
          >
            {socialLinks.map((social, index) => (
              <a
                key={index}
                href={social.url}
                target="_blank"
                rel="noopener noreferrer"
                className="bg-black rounded-lg p-6 border border-gray-700 hover:border-red-500 transition-all duration-300 hover:scale-105"
              >
                <div className="text-3xl mb-2">
                  {social.name === 'Spotify' && '🎵'}
                  {social.name === 'Bandcamp' && '💿'}
                  {social.name === 'Instagram' && '📷'}
                  {social.name === 'Facebook' && '📘'}
                </div>
                <p className="text-white font-semibold">{social.name}</p>
              </a>
            ))}
          </motion.div>
        </div>
      </section>

      {/* Response Times */}
      <section className="py-20 bg-black">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.h2 
            className="text-3xl font-bold bebas-neune gradient-text mb-8 text-center"
            initial={{opacity: 0, y: 30}}
            whileInView={{opacity: 1, y: 0}}
            transition={{duration: 0.8}}
            viewport={{once: true}}
          >
            Response Times
          </motion.h2>
          <motion.div 
            className="space-y-4"
            initial={{opacity: 0, y: 30}}
            whileInView={{opacity: 1, y: 0}}
            transition={{duration: 0.8, delay: 0.2}}
            viewport={{once: true}}
          >
            {[
              {type: 'Fan Mail', time: 'Within 24 hours', icon: FiMessageCircle},
              {type: 'Booking Inquiries', time: 'Within 48 hours', icon: FiCalendar},
              {type: 'Press Requests', time: 'Within 72 hours', icon: FiMusic},
              {type: 'Business Matters', time: 'Within 1 week', icon: FiDollarSign}
            ].map((item, index) => (
              <div key={index} className="bg-gray-900 rounded-lg p-4 border border-gray-700 flex items-center space-x-4">
                <div className="bg-yellow-600 rounded-full w-8 h-8 flex items-center justify-center">
                  <SafeIcon icon={item.icon} className="h-4 w-4 text-white" />
                </div>
                <div className="flex-1">
                  <h4 className="text-white font-semibold">{item.type}</h4>
                  <p className="text-gray-400 text-sm">{item.time}</p>
                </div>
              </div>
            ))}
          </motion.div>
          <motion.div 
            className="mt-6 bg-red-900/20 border border-red-500/30 rounded-lg p-4"
            initial={{opacity: 0, y: 30}}
            whileInView={{opacity: 1, y: 0}}
            transition={{duration: 0.8, delay: 0.4}}
            viewport={{once: true}}
          >
            <p className="text-red-300 text-sm">
              <strong>Note:</strong> Response times may be slower during tour dates, recording sessions, 
              or when we're arguing about who forgot to tune their instrument.
            </p>
          </motion.div>
        </div>
      </section>
    </div>
  );
}

export default Contact;